module.exports = __webpack_public_path__ + "static/media/banner.910bccb0.jpg";